export default {
  id: {
    "ui:options": {
      label: false,
    },
    "ui:widget": "hidden",
  },
  isEnabled: {
    "ui:widget": "toggle",
    "ui:options": {
      labels: [
        { label: "Enable", value: true },
        { label: "Disable", value: false },
      ],
    },
  },
  "ui:order": ["isEnabled", "measure", "value", "period"],
};
